import _ from "lodash";
export var hasUpperCase = function (text) {
    return /[A-Z]/.test(text);
};
export var hasLowerCase = function (text) {
    return /[a-z]/.test(text);
};
export var hasSymbol = function (text) {
    return /[@$!%*#?&~-]/.test(text);
};
export var checkIsHex = function (string) {
    for (var i = 0; i < string.length; i++) {
        if ((string[i] < "0" || string[i] > "9") && (string[i] < "A" || string[i] > "F")) {
            return false;
        }
    }
    return true;
};
// This function will convert hex string value to an int.
export function toInt(hex) {
    if (checkIsHex(hex)) {
        return parseInt("0x" + hex);
    }
    else {
        return -1;
    }
}
// Converts a byteArray to an hex string.
// The library handles data as byteArrays so use this method
// to get the hex string representation of the array.
export function toHexString(byteArray) {
    return byteArray
        .map(function (byte) {
        return toHex(byte);
    })
        .join("")
        .toUpperCase();
}
// This function is used for returning an integer representation of a version.
export function toVersionInt(hex) {
    if (hex.length !== 6) {
        throw new Error("Hex invalid length");
    }
    if (checkIsHex(hex)) {
        var major = toInt(hex.substring(0, 2)) * 372;
        var mid = toInt(hex.substring(2, 4)) * 31;
        var minor = toInt(hex.substring(4, 6));
        return major + mid + minor;
    }
    else {
        throw new Error("Invalid Hex");
    }
}
// This function is going to take a 3 byte string of hex values and convert it into a version.
// The version is going to be major.mid.minor format.
export function hexToVersion(hex) {
    if (hex.length !== 6) {
        throw new Error("Hex string is invalid length");
    }
    if (checkIsHex(hex)) {
        var major = toInt(hex.substring(0, 2));
        var mid = toInt(hex.substring(2, 4));
        var minor = toInt(hex.substring(4, 6));
        return major.toString() + "." + mid.toString() + "." + minor.toString();
    }
    else {
        throw new Error("Invalid hex");
    }
}
// This method is for converting the length of the hex string to
// Hex. For example if the length of the string is 10, this method
// returns 0A. Since 10 decimal is 0A in Hex.
export function toHex(decimalNumber, minByteSize) {
    if (minByteSize === void 0) { minByteSize = 1; }
    if (minByteSize < 1 || minByteSize % 1 !== 0) {
        throw new Error("minByteSize must be a positive integer");
    }
    var hex = Number(decimalNumber).toString(16).toUpperCase();
    return _.padStart(hex, minByteSize * 2, "0");
}
export function titleCase(str) {
    return _.startCase(_.toLower(str));
}
export function reverseString(string) {
    return string.split("").reverse().join("");
}
export function countInstances(string, word) {
    if (string === "")
        throw new Error("String to check is empty");
    return string.split(word).length - 1;
}
// This function converts a hex string to ASCII.
// We use this when we are converting a command that is from by the hand.
export function toASCIIString(data) {
    if (checkIsHex(data)) {
        var str = "";
        for (var i = 0; i < data.length; i += 2) {
            str += String.fromCharCode(parseInt(data.substring(i, i + 2), 16));
        }
        return str;
    }
    else {
        throw new Error("Invalid hex");
    }
}
export function timeout(delay) {
    return new Promise(function (res) { return setTimeout(res, delay); });
}
export function stringTwoPartVersionToHex(version) {
    if (version === "")
        throw new Error("Version to convert is empty string");
    var _version = version.replace(".", "");
    if (_version.length > 3)
        throw new Error("Not correct length");
    while (_version.length < 3)
        _version += "0";
    var major = toHex(parseInt(_version.charAt(0)));
    var mid = toHex(parseInt(_version.charAt(1)));
    var minor = toHex(parseInt(_version.charAt(2)));
    return major + mid + minor;
}
export var checkProtectedConfigNames = function (configName, userRole) {
    var protectedNames = [
        "factory",
        "default",
        "repair",
        "update",
        "archived",
        "live config",
        "covvi support",
    ];
    var error = "";
    configName.trim().length === 0 && (error = "must_name");
    !configName.match(/^([a-zA-Z0-9 _-]+)$/) && (error = "no_special_char");
    protectedNames.forEach(function (protectedName) {
        return configName.toLowerCase().includes(protectedName) &&
            !["Admin", "Tech Team Member"].includes(userRole) &&
            (error = "no_".concat(protectedName.replace(" ", "_")));
    });
    if (configName.trim().toLowerCase().startsWith("rma") &&
        !["Admin", "Tech Team Member"].includes(userRole))
        error = "rma_prefix_warning";
    if (configName.trim().toLowerCase().startsWith("ncmr") &&
        !["Admin", "Tech Team Member"].includes(userRole))
        error = "ncmr_prefix_warning";
    return error;
};
